// icons.js — icons for the v2 marketing home page (ported from website2-icons.jsx).
// N2Ic: marketing stroke glyphs (24 viewBox) · NIc: the real app glyph set (16 viewBox)
// · N2Paw / NPaw: filled paw marks.
import React from 'react'

export function N2Paw({ size = 16 }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{ flex: 'none' }}>
			<ellipse cx="7.2" cy="8.4" rx="2.1" ry="2.7" transform="rotate(-18 7.2 8.4)"></ellipse>
			<ellipse cx="16.8" cy="8.4" rx="2.1" ry="2.7" transform="rotate(18 16.8 8.4)"></ellipse>
			<ellipse cx="3.6" cy="13.2" rx="1.8" ry="2.3" transform="rotate(-38 3.6 13.2)"></ellipse>
			<ellipse cx="20.4" cy="13.2" rx="1.8" ry="2.3" transform="rotate(38 20.4 13.2)"></ellipse>
			<path d="M12 11.2c2.9 0 5.6 2.4 5.6 5.1 0 1.9-1.4 3.2-3.2 3.2-.9 0-1.7-.3-2.4-.3s-1.5.3-2.4.3c-1.8 0-3.2-1.3-3.2-3.2 0-2.7 2.7-5.1 5.6-5.1z"></path>
		</svg>
	)
}

export function N2Ic({ name, size = 18, sw = 1.7 }) {
	const P = {
		check: <path d="M4 12.5l4.5 4.5L20 6.5" />,
		arrow: <path d="M4 12h15m0 0l-6-6m6 6l-6 6" />,
		calendar: <><rect x="3.5" y="5" width="17" height="15.5" rx="3" /><path d="M3.5 10h17M8 2.8V6.5M16 2.8V6.5" /></>,
		globe: <><circle cx="12" cy="12" r="8.5" /><path d="M3.5 12h17M12 3.5c2.4 2.2 3.6 5.2 3.6 8.5s-1.2 6.3-3.6 8.5c-2.4-2.2-3.6-5.2-3.6-8.5s1.2-6.3 3.6-8.5z" /></>,
		card: <><rect x="3" y="5.5" width="18" height="13.5" rx="3" /><path d="M3 10h18M7 15h4" /></>,
		bell: <><path d="M18 10.5a6 6 0 10-12 0c0 5-2.2 6.5-2.2 6.5h16.4S18 15.5 18 10.5z" /><path d="M10.2 20.5a2 2 0 003.6 0" /></>,
		shield: <><path d="M12 3l7.5 3v5.5c0 4.6-3 8-7.5 9.5-4.5-1.5-7.5-4.9-7.5-9.5V6L12 3z" /><path d="M9 12l2.2 2.2L15.5 9.8" /></>,
		grid: <><rect x="3.5" y="3.5" width="7" height="7" rx="1.8" /><rect x="13.5" y="3.5" width="7" height="7" rx="1.8" /><rect x="3.5" y="13.5" width="7" height="7" rx="1.8" /><rect x="13.5" y="13.5" width="7" height="7" rx="1.8" /></>,
		inbox: <><path d="M12 5C10.3 3.7 7.9 3 4.5 3v14.5c3.4 0 5.8.7 7.5 2 1.7-1.3 4.1-2 7.5-2V3C16.1 3 13.7 3.7 12 5z" /><path d="M12 5v14.5" /></>,
		users: <><circle cx="9" cy="8.5" r="3.5" /><path d="M3.5 19.5c0-3 2.5-5 5.5-5s5.5 2 5.5 5" /><path d="M16 5.5a3.5 3.5 0 010 6.5M17.5 14.7c2 .6 3.4 2.3 3.4 4.8" /></>,
		spark: <path d="M12 3l1.9 5.6L19.5 10.5l-5.6 1.9L12 18l-1.9-5.6L4.5 10.5l5.6-1.9L12 3z" />,
		clock: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3.2 2.2" /></>,
		chat: <><path d="M4 6.5A2.5 2.5 0 016.5 4h11A2.5 2.5 0 0120 6.5v8a2.5 2.5 0 01-2.5 2.5H9l-4.5 3.5V6.5z" /><path d="M8.5 9.5h7M8.5 12.7h4.5" /></>,
		repeat: <><path d="M17.5 3.5l3 3-3 3" /><path d="M20.5 6.5H8A4.5 4.5 0 003.5 11M6.5 20.5l-3-3 3-3" /><path d="M3.5 17.5H16a4.5 4.5 0 004.5-4.5" /></>,
		send: <path d="M20.5 3.5L10 14M20.5 3.5L13.5 20.5 10 14 3.5 10.5 20.5 3.5z" />,
		zap: <path d="M13 2.5L4.5 13.5H11L10 21.5 19.5 10.5H13l1-8z" />,
		heart: <path d="M12 20.5s-8.5-5.1-8.5-11A4.6 4.6 0 0112 6.6a4.6 4.6 0 018.5 2.9c0 5.9-8.5 11-8.5 11z" />,
		pen: <path d="M4 20l1-4L16.5 4.5a2.1 2.1 0 013 3L8 19l-4 1z" />,
		phone: <><rect x="6.5" y="2.5" width="11" height="19" rx="3" /><path d="M10.5 18.5h3" /></>,
		chevron: <path d="M8 10l4 4 4-4" />,
		plus: <path d="M12 5v14M5 12h14" />,
		scissors: <><circle cx="6.5" cy="6.5" r="2.6" /><circle cx="6.5" cy="17.5" r="2.6" /><path d="M8.8 8.2L20 19M8.8 15.8L20 5" /></>,
		mail: <><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="M3.6 6.5L12 12.8l8.4-6.3" /></>,
		menu: <path d="M4 6.5h16M4 12h16M4 17.5h16" />,
		x: <path d="M6 6l12 12M18 6L6 18" />,
		receipt: <><path d="M6 3h12v18l-2.4-1.6L13.2 21l-2.4-1.6L8.4 21 6 19.4V3z" /><path d="M9.5 8h5M9.5 12h5" /></>,
		tap: <><path d="M12 8.5a3.5 3.5 0 013.5 3.5" /><path d="M12 5a7 7 0 017 7" /><path d="M5.5 13.5V9a1.75 1.75 0 013.5 0v5l3.6-1.1a2 2 0 012.5 1.4l.7 2.7a3 3 0 01-2.9 3.8H10a4.5 4.5 0 01-4.5-4.3z" /></>
	}
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
			strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
			{P[name] || null}
		</svg>
	)
}

/* the real in-app glyphs — verbatim from components/icons/Icon.jsx */
export function NIc({ name, size = 16, sw = 1.7 }) {
	const G = {
		dashboard: <><rect x="2" y="2" width="4.6" height="4.6" rx="1" /><rect x="9.4" y="2" width="4.6" height="4.6" rx="1" /><rect x="2" y="9.4" width="4.6" height="4.6" rx="1" /><rect x="9.4" y="9.4" width="4.6" height="4.6" rx="1" /></>,
		calendar: <><rect x="2" y="3" width="12" height="11" rx="2" /><path d="M2 6.5h12M5.5 1.5v3M10.5 1.5v3" /></>,
		bookings: <><path d="M8 3.5C6.8 2.5 5 2 2.5 2v11c2.5 0 4.3.5 5.5 1.5 1.2-1 3-1.5 5.5-1.5V2C11 2 9.2 2.5 8 3.5z" /><path d="M8 3.5v11" /></>,
		pets: <><circle cx="5" cy="4.2" r="1.4" /><circle cx="11" cy="4.2" r="1.4" /><circle cx="2.8" cy="8" r="1.3" /><circle cx="13.2" cy="8" r="1.3" /><path d="M8 7.4c1.9 0 3.6 1.6 3.6 3.4 0 1.3-.9 2.2-2.1 2.2-.6 0-1-.2-1.5-.2s-.9.2-1.5.2c-1.2 0-2.1-.9-2.1-2.2 0-1.8 1.7-3.4 3.6-3.4z" /></>,
		employees: <><circle cx="5.7" cy="5.2" r="2.2" /><path d="M1.8 13.5c0-2.2 1.7-3.8 3.9-3.8s3.9 1.6 3.9 3.8" /><circle cx="11.4" cy="5.6" r="1.8" /><path d="M11.2 9.9c1.8.1 3 1.5 3 3.2" /></>,
		services: <><path d="M5.5 4.2h8.5M5.5 8h8.5M5.5 11.8h8.5" /><circle cx="2.4" cy="4.2" r=".9" fill="currentColor" stroke="none" /><circle cx="2.4" cy="8" r=".9" fill="currentColor" stroke="none" /><circle cx="2.4" cy="11.8" r=".9" fill="currentColor" stroke="none" /></>,
		messages: <path d="M2.5 3.5h11v8h-6L4 14v-2.5H2.5v-8z" />,
		agreements: <><path d="M3.5 1.5h6L13 5v9.5H3.5v-13z" /><path d="M9 1.5V5h4M5.8 8h4.4M5.8 10.8h4.4" /></>,
		landing: <><rect x="2" y="2.5" width="12" height="11" rx="1.5" /><path d="M6.5 2.5v11M2 6h4.5" /></>,
		settings: <><circle cx="8" cy="8" r="2.2" /><path d="M8 1.8v2M8 12.2v2M1.8 8h2M12.2 8h2M3.6 3.6l1.4 1.4M11 11l1.4 1.4M12.4 3.6L11 5M5 11l-1.4 1.4" /></>,
		help: <><circle cx="8" cy="8" r="6.2" /><path d="M6.2 6.3A1.9 1.9 0 018 5c1 0 1.9.7 1.9 1.7 0 1.2-1.9 1.3-1.9 2.6" /><circle cx="8" cy="11.2" r=".8" fill="currentColor" stroke="none" /></>,
		logout: <><path d="M6 1.5H2.5v13H6" /><path d="M6.5 8h8M11.5 5l3 3-3 3" /></>,
		collapse: <path d="M9.5 4.5L6 8l3.5 3.5" />,
		search: <><circle cx="7" cy="7" r="4.6" /><path d="M10.5 10.5L14 14" /></>,
		bell: <><path d="M8 2a4 4 0 014 4c0 3 1.2 4 1.2 4H2.8S4 9 4 6a4 4 0 014-4z" /><path d="M6.7 13a1.4 1.4 0 002.6 0" /></>,
		plus: <path d="M8 3.5v9M3.5 8h9" />,
		x: <path d="M4 4l8 8M12 4l-8 8" />,
		tick: <path d="M3 8.5l3.2 3L13 4.5" />,
		chevron: <path d="M4.5 6.5L8 10l3.5-3.5" />,
		chevl: <path d="M9.5 4.5L6 8l3.5 3.5" />,
		chevr: <path d="M6.5 4.5L10 8l-3.5 3.5" />,
		clock: <><circle cx="8" cy="8" r="6" /><path d="M8 4.5V8l2.5 1.5" /></>,
		user: <><circle cx="8" cy="5.5" r="2.8" /><path d="M2.8 14c.9-2.6 2.9-4 5.2-4s4.3 1.4 5.2 4" /></>,
		pencil: <path d="M3 13l.8-3L11 2.8a1.45 1.45 0 012.1 2L5.8 12 3 13z" />,
		warn: <><path d="M8 2.4L14.4 13.2H1.6L8 2.4z" /><path d="M8 6.8v3M8 11.4v.01" /></>,
		checkc: <><circle cx="8" cy="8" r="6" /><path d="M5.3 8.2l1.9 1.9 3.5-3.8" /></>,
		spark: <path d="M8 1.8l1.3 3.9 3.9 1.3-3.9 1.3L8 12.2 6.7 8.3 2.8 7l3.9-1.3L8 1.8z" />,
		phone: <><rect x="4" y="1.5" width="8" height="13" rx="2" /><path d="M6.8 12.5h2.4" /></>,
		trash: <><path d="M2.8 4.4h10.4M6 4.4V3.1a1 1 0 011-1h2a1 1 0 011 1v1.3M4 4.4l.6 8.2a1 1 0 001 .9h4.8a1 1 0 001-.9l.6-8.2" /></>,
		mail: <><rect x="1.6" y="3.2" width="12.8" height="9.6" rx="1.6" /><path d="M2.2 4.2L8 8.6l5.8-4.4" /></>,
		pin: <><path d="M8 14.5s4.7-4.2 4.7-7.6A4.7 4.7 0 008 2.2a4.7 4.7 0 00-4.7 4.7C3.3 10.3 8 14.5 8 14.5z" /><circle cx="8" cy="6.9" r="1.7" /></>,
		sort: <><path d="M5 6.2L5 12M5 12L3.3 10.2M5 12l1.7-1.8" /><path d="M11 9.8L11 4M11 4L9.3 5.8M11 4l1.7 1.8" /></>,
		dot: <circle cx="8" cy="8" r="3" fill="currentColor" stroke="none" />
	}
	return (
		<svg width={size} height={size} viewBox="0 0 16 16" fill="none" stroke="currentColor"
			strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}>
			{G[name] || null}
		</svg>
	)
}

/* small filled paw for in-app avatars (16 viewBox, matches Paw glyph) */
export function NPaw({ size = 14 }) {
	return (
		<svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" style={{ flex: 'none' }}>
			<circle cx="5" cy="4.2" r="1.5"></circle><circle cx="11" cy="4.2" r="1.5"></circle>
			<circle cx="2.7" cy="8" r="1.35"></circle><circle cx="13.3" cy="8" r="1.35"></circle>
			<path d="M8 7.2c2 0 3.8 1.7 3.8 3.6 0 1.4-1 2.4-2.3 2.4-.6 0-1-.2-1.5-.2s-.9.2-1.5.2c-1.3 0-2.3-1-2.3-2.4C4.2 8.9 6 7.2 8 7.2z"></path>
		</svg>
	)
}
